import { registerBlockType } from "@wordpress/blocks";
import Edit from "./edit";
import metadata from "./block.json";
import "./styles/index.css";

const iconSVG = <span class="dashicons dashicons-excerpt-view"></span>;

registerBlockType(metadata.name, {
  icon: iconSVG,
  edit: Edit,
});
